// components/ReservationModal.jsx
import { useState } from "react";
import { motion } from "framer-motion";
import { FiPlus, FiMinus, FiX, FiShoppingCart } from "react-icons/fi";
import useCartStore from "../store/cartStore";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function ReservationModal({ isOpen, onClose, service, selectedDate }) {
  const [quantity, setQuantity] = useState(1);
  const { items, addToCart } = useCartStore();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleAddToCart = () => {
    if (!service || !service.id) {
      toast.error("Service invalide");
      return;
    }

    addToCart(service, selectedDate, quantity);
    toast.success(`Service ajouté au panier (x${quantity})`);
    onClose();
    setQuantity(1);

    setTimeout(() => {
      navigate("/services");
    }, 1000);
  };

  const handleContinueShopping = () => {
    handleAddToCart();
    navigate("/services");
  };

  const handleGoToCart = () => {
    // handleAddToCart();
    navigate("/cart");
  };

  const increaseQuantity = () => {
    setQuantity((prev) => prev + 1);
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity((prev) => prev - 1);
    }
  };

  const totalPrice = service?.price ? service.price * quantity : 0;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[100] p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="bg-white max-w-md w-full h-[80vh] flex flex-col shadow-2xl overflow-hidden"
      >
        {/* En-tête fixe */}
        <div className="flex-none p-3 border-b flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
              <FiShoppingCart className="text-white text-sm" />
            </div>
            <h2 className="font-poppins font-bold text-[15px] text-gray-800">
              Ajouter au panier
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 transition-all duration-200"
          >
            <FiX size={18} className="text-gray-500" />
          </button>
        </div>

        {/* Contenu scrollable */}
        <div className="flex-1 overflow-y-auto p-3 space-y-4">
          {/* Détails du service */}
          <div className="p-3 bg-gray-50 border border-gray-100">
            <h3 className="font-poppins font-bold text-[15px] text-gray-800 mb-1">
              {service?.nom}
            </h3>
            <p className="font-nunito font-light text-sm text-gray-600 mb-3">{service?.description}</p>

            <div className="flex justify-between items-center mb-2">
              <span className="font-poppins font-bold text-[16px] text-secondary">
                {service?.price} FCFA
              </span>
            </div>

            <div className="mt-2 font-nunito font-light text-[12px] text-gray-500 bg-white p-2 border border-gray-100">
              <span className="font-bold">Date :</span> {selectedDate}
            </div>
          </div>

          {/* Sélecteur de quantité */}
          <div className="space-y-3">
            <label className="block font-poppins font-bold text-[13px] text-gray-700">
              Quantité
            </label>
            <div className="flex items-center justify-center bg-gray-50 p-3 border border-gray-100">
              <button
                onClick={decreaseQuantity}
                disabled={quantity <= 1}
                className={`w-10 h-10 flex items-center justify-center transition-all ${quantity <= 1
                    ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                    : "bg-white text-primary border border-primary hover:bg-primary hover:text-white"
                  }`}
              >
                <FiMinus size={16} />
              </button>

              <span className="font-poppins font-bold text-[18px] text-gray-800 mx-8 min-w-[24px] text-center">
                {quantity}
              </span>

              <button
                onClick={increaseQuantity}
                className="w-10 h-10 flex items-center justify-center bg-primary text-white hover:opacity-90 transition-all"
              >
                <FiPlus size={16} />
              </button>
            </div>
          </div>

          {/* Total résumé */}
          <div className="p-3 bg-gradient-to-r from-primary/5 to-secondary/5 border border-primary/10">
            <div className="flex justify-between items-center">
              <span className="font-poppins font-bold text-[13px] text-gray-600">Total :</span>
              <span className="font-poppins font-bold text-[18px] text-primary">
                {totalPrice} FCFA
              </span>
            </div>
          </div>
        </div>

        {/* Pied fixe */}
        <div className="flex-none p-3 border-t bg-gray-50 space-y-2">
          <button
            onClick={handleAddToCart}
            className="w-full py-3 bg-gradient-to-r from-primary to-secondary text-white hover:opacity-90 transition-all font-nunito font-bold text-sm flex items-center justify-center gap-2 shadow-md"
          >
            <FiShoppingCart size={16} />
            Ajouter au panier
          </button>

          <div className="grid grid-cols-2 gap-2">
            <button
              onClick={handleContinueShopping}
              className="py-2 border border-gray-300 font-nunito font-bold text-[12px] text-gray-600 hover:bg-white transition-all"
            >
              Continuer
            </button>
            <button
              disabled={items.length === 0}
              onClick={handleGoToCart}
              className={`py-2 bg-gray-800 ${items.length === 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-black"
                } text-white transition-all font-nunito font-bold text-[12px]`}
            >
              Voir panier
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default ReservationModal;